import { OutlinedButton } from "@components/atoms/base-button";
import { translate } from "@locales";
import { truncateText } from "@models/interactions/truncate-text";
import { useFormat } from "@models/interactions/use-format";
import { Link } from "@shopify/hydrogen";

export function EducationalPreview({ blog }) {
  return (
    <div className="mb-[25px] flex max-sm:flex-col lg:flex-row lg:mt-0 sm:mt-6 lg:mx-0 max-sm:mx-5 lg:mb-0 sm:mb-[35px] lg:h-[390px] sm:h-[488px] hover:shadow-lg">
      <img
        src={blog.image.url ?? "/static/img/BlogCover.png"}
        alt="Blog Cover Image"
        className="sm:w-full lg:w-[230px] 2xl:w-[382px] lg:h-[390px] max-sm:h-[201px] lg:pb-0 sm:pb-4 object-cover"
      />
      <div className="sm:w-full lg:h-[346px] lg:w-[244px] lg:ml-[30px] lg:mr-[34px] lg:my-9 sm:h-[182px] max-sm:pb-[25px] max-sm:px-[11px]">
        <div className="flex flex-col sm:h-[250px]">
          <span className="font-chivo-regular lg:text-xs max-sm:text-[12px] text-custom-gray text-left lg:pb-3 sm:pb-[9px]">
            {useFormat(blog.publishedAt)}
          </span>
          <h2 className="max-sm:text-lg22 lg:text-[22px] 2xl:text-[25px] inline-block text-left font-chivo-italic pb-2.5">
            {truncateText(blog.title, 30)}
          </h2>
          <div className="flex space-x-[8px] lg:pb-[26px] max-sm:pb-3">
            {blog.tags.map((tag) => {
              return (
                <div className="w-auto h-5 text-white bg-dark-gray rounded-sm ">
                  <p className="font-chivo-regular text-[10px] uppercase m-1">
                    #{tag}
                  </p>
                </div>
              );
            })}
          </div>
          <p className="flex font-chivo-light lg:text-xs max-sm:text-[12px] lg:pb-[25px] max-sm:pb-4">
            {truncateText(blog.content, 150)}
          </p>
        </div>
        <Link to={`/blogs/educational/${blog.handle}`}>
          <OutlinedButton className="max-sm:w-full text-sm lg:w-[218px] h-[55px] hover:bg-black hover:text-white">
            {translate("base.read-more")}
          </OutlinedButton>
        </Link>
      </div>
    </div>
  );
}
